module.exports = __webpack_public_path__ + "static/media/qassim.6e380c34.webp";